import { deSoftwarePackages } from './pages/softwarePackages/de.softwarePackages';
import { PressRoomImages } from '@helpers/staticImages/pressRoom';
import { contactUs } from '@helpers/staticImages/staticPages';

export const de = {
    notFound: {
        title: '404 Nicht gefunden | Geotab',
        heading: 'Tut uns leid!',
        description: 'Die gesuchte Seite konnte nicht gefunden werden.',
        description2: 'Nutzen Sie die Suche oder gehen Sie zurück zu',
        homepageLink: 'unserer Homepage',
    },
    salesforce: {
        formLanguage: 'German DE',
        demoFormDefaultCampaignId: '7012J000001YfkCQAS',
    },
    transportationContactForm: {
        title: 'Optimieren Sie Ihre Lkw-Flotte noch heute',
        subTitle:
            'Gewinnen Sie nützliche Einblicke in flexible, kostengünstige Wettbewerbsstrategien für Lkw-Flotten in Deutschland und Europa.',
        formField: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            company: 'Unternehmen',
            email: 'E-Mail',
            phone: 'Rufnummer',
            city: 'Ort',
            selectCountry: 'Land',
            fleetSize: 'Fleet Size',
            consentTextSentences: [
                'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen von Geotab erhalten. ',
                'Die Daten werden in Übereinstimmung von ',
            ],
            consentLinkText: 'Datenschutzrichtlinien von Geotab ',
            consentTextEnding: 'verwendet.',
            consentLink: 'https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub',
            submit: 'Senden',
        },
    },
    siteWideDemoForm: {
        formField: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            company: 'Unternehmen',
            title: 'Berufsbezeichnung',
            email: 'E-Mail',
            industry: 'Branche',
            fleetSize: 'Größe des Fuhrparks wählen',
            phone: 'Rufnummer',
            country: 'Land wählen',
            state: 'Bundesland',
            city: 'Ort',
            selfAttribution: 'Wie haben Sie von uns erfahren?',
            multipleRegionText: 'Ist Ihr Unternehmen in mehreren Regionen tätig? (Optional)',
            consentText:
                'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen zu Geotab.com erhalten. Ihre Daten werden gemäß der <a href="https://docs.google.com/document/d/1YGouMy1BZtcyF3wGxyKZ0OVYurqh0k7eBL6dNjjWSrk/pub">Datenschutzrichtlinie</a> von Geotab verwendet.',
        },
        helperText: {
            forceMultiPick: 'Wählen Sie mindestens zwei Optionen',
        },
        returnToPrevious: 'Zurück',
        a11yInstructions:
            'Dieses Formular besteht aus mehreren Seiten. Um zur nächsten Seite zu gelangen, füllen Sie bitte die folgenden Felder oder Kästchen aus.',
    },
    resellerForm: {
        seo: {
            title: 'Fachhändler werden | Geotab',
            description:
                'Möchten Sie ein Geotab-Fachhändler werden? Bitte füllen Sie das Formular aus, damit wir Sie so bald wie möglich kontaktieren können.',
        },
        heroImagePath: contactUs.resellerSupport,
        title: 'Fachhändler werden',
        header: 'Fachhändler-Support kontaktieren',
        subtext:
            'Möchten Sie ein Geotab-Fachhändler werden? Bitte füllen Sie dieses Formular aus, damit wir Sie so bald wie möglich kontaktieren können.',
        inquiryType: 'Become a Reseller/Partner',
    },
    contactUsForm: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        phone: 'Telefon',
        email: 'E-Mail-Adresse',
        company: 'Firma',
        fleetSize: 'Größe des Fuhrparks',
        country: 'Land',
        city: 'Ort',
        comments: 'Fragen/Kommentare:',
        checkboxText:
            'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen von Geotab.com erhalten. Ihre Daten werden gemäß der Datenschutzrichtlinie von Geotab verwendet.',
        submit: 'Senden',
        languageCode: 'German DE',
        consentTextEU:
            'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen zu Geotab.com erhalten. Ihre Daten werden gemäß der <a href="https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub" target="_blank">Datenschutzrichtlinie von Geotab</a> verwendet.',
        yes: 'Ja',
        no: 'Nein',
    },
    categories: {
        all: 'Alle Beiträge',
        allCategoriesTitleTag: 'Alle Beiträge anzeigen',
        categoriesTitleTag: 'Beiträge anzeigen',
        geotabAuthor: 'Geotab Autor',
        page: 'Seite',
        fleetManagementBlog: 'Fuhrpark Management Blog',
    },
    blogHome: {
        seo: {
            title: 'Geotab Blog | Flottenmanagement-Blog',
            description:
                'Lesen Sie die neuesten Updates zu Flottenmanagement-Lösungen und -Technologien | Flottenmanagement-Blog',
        },
        featured: 'Highlights',
        browseCategories: 'Kategorien durchsuchen',
        editorsPicks: 'Unsere Auswahl',
        newestPosts: 'Aktuelle Beiträge',
        viewAll: 'Alle anzeigen',
        mostRecent: 'Neueste',
    },
    pressRoomHome: {
        seo: {
            title: 'Pressebereich und Medien-News | Geotab',
            description:
                'Im Pressebereich und den Medien-News finden Sie die neuesten Nachrichten rund um Telematik und Fuhrparkmanagement sowie neueste Informationen zu Geotab.',
        },
        allPressReleases: 'Alle Pressemitteilungen',
        pressKit: {
            pressKitTitle: 'Pressemappe',
            ourAvailableResources:
                'Unsere Ressourcen für Journalisten. Bei Medienanfragen senden Sie bitte eine E-Mail an: ',
            pressKitList: [
                {
                    name: 'Unternehmensprofil',
                    url: '/de/ueber/',
                    image: PressRoomImages.corpProfile,
                },
                {
                    name: 'Biografien der Geschäftsleitung',
                    url: '/de/ueber/geschaeftsleitung/',
                    image: PressRoomImages.leadershipBio,
                },
                {
                    name: 'Datenblatt',
                    url: 'https://docs.google.com/document/d/1Bct3-Z9FCtl15C7DS8iGWtoE7Ckc6IgvRbv9cRqmYFw/edit?usp=sharing',
                    image: PressRoomImages.mediaGuidelines,
                },
                {
                    name: 'Richtlinien für Partner-Pressemitteilungen',
                    url: 'https://docs.google.com/document/d/1op_dyBGG99rBjB4GEcV8vArEqrXKo7pqoNG3l-kuqkY/edit?usp=sharing',
                    image: PressRoomImages.legalPolicy,
                },
            ],
        },
        pressRoomSectionListCards: {
            latestUpdates: 'Letzte News',
            inOtherNews: 'Weitere News',
        },
    },
    pagination: {
        page: 'Seite',
        of: 'von',
    },
    articleTypes: {
        pressRelease: 'Presse',
        caseStudy: 'Success stories',
        blog: 'Blog',
        whitePaper: 'White paper',
        video: 'Video',
        glossary: 'Glossar',
    },
    articleTypesAction: {
        viewAll: 'Alle ansehen',
        filter: 'Filter',
    },
    myGeotabLogin: {
        loginText: 'Anmelden',
        registerText: 'Registrieren',
        newsText: 'Neues',
        seo: {
            title: 'MyGeotab Anmelden / Registrieren | Deutschland | Geotab',
            description:
                'Melden Sie sich sicher bei Ihrem MyGeotab-Dashboard an. Sie haben kein Konto? Registrieren Sie sich als neuer Benutzer in Deutschland.',
        },
        heading: 'Deutschland MyGeotab Anmelden / Registrieren',
    },
    whitePapersHome: {
        seo: {
            title: 'Fleet Management Whitepaper Reads',
            description:
                'The latest Whitepapers from Geotab. Learn how Geotab`s end to end fleet management solution can help your business.',
        },
        page: 'Page',
        title: 'White papers',
    },
    whitePaper: {
        articleCard: {
            publishedOn: 'Veröffentlichungsdatum',
            downloadWhitePaper: 'Whitepaper herunterladen',
        },
        allWhitePapers: 'Alle white papers',
    },
    becomeInstaller: {
        seo: {
            title: 'Werden Sie ein autorisierter Installationspartner | Geotab',
            description: 'Füllen Sie das Formular aus und werden Sie ein Geotab-Hardware Installationsbetrieb',
        },
        title: 'Werden Sie ein autorisierter Installationspartner',
        companyDetails: {
            title: 'Unternehmensdaten',
            description1:
                'Pro Unternehmen ist nur EINE Bewerbung erforderlich. Wenn sich Ihr Unternehmen bereits beworben hat und Sie die Zertifizierung zum autorisierten Installierer absolvieren möchten, gehen Sie zu',
            takeTest: 'Test starten',
            description2: 'und geben Sie die Ihrem Unternehmen zugewiesene Unternehmensnummer ein.',
            takeTestLinkPath: 'installierertest/',
        },
        stepOneForm: {
            companyName: 'Firmenname',
            email: 'E-Mail-Adresse',
            website: 'Website',
            phoneNumber: 'Telefonnummer',
            streetAddress: 'Straße',
            city: 'Ort',
            selectCountry: 'Land',
            stateProvince: 'Bundesland',
            postalCode: 'Postleitzahl',
            next: 'Weiter',
        },
        stepTwo: {
            title: 'Bewerbung als Installationsbetrieb und Vereinbarung – Nutzungsbedingungen',
            note: 'Hinweis: Sie müssen nach unten scrollen, um die Vereinbarung akzeptieren zu können.',
            iAgree: 'Akzeptieren',
            back: 'Zurück',
            agreement: `1. Ernennung zum zertifizierten Installationsbetrieb: Nach erfolgreichem Abschluss aller Schulungs-, Test- und Zertifizierungsanforderungen („Zertifizierungsanforderungen“), die wir von Zeit zu Zeit festlegen oder ändern können, durch mindestens einen Ihrer Mitarbeiter („zertifizierte Person“) ernennen wir Sie vorbehaltlich der Bestimmungen und Bedingungen dieser Vereinbarung zu einem zertifizierten Installationsbetrieb für unsere Produkte („zertifizierter Geotab-Installationsbetrieb“), und Sie erklären sich damit einverstanden, als zertifizierter Installationsbetrieb unserer Produkte zu fungieren, um Benutzern oder Fachhändlern unserer Produkte („Geotab-Benutzer“) in Form der zertifizierten Personen Ihre Installations-, Konfigurations-, Einrichtungs- und andere Dienste („Installationsdienste“) anzubieten. Wir behalten uns das Recht vor, in einem beliebigen Gebiet nach eigenem Ermessen jederzeit weitere zertifizierte Geotab-Installationsbetriebe zu ernennen. Sie tragen die alleinige Verantwortung für Ihre Geschäfte mit Geotab-Benutzern, für alle Ausgaben, die Ihnen im Zusammenhang mit solchen Transaktionen entstehen, sowie für alle Gebühren oder anderen Beträge, die Ihnen geschuldet werden. Diese Vereinbarung gewährt Ihnen keine Rechte zum Verkauf oder Weiterverkauf unserer Produkte oder automatisierten Dienstleistungen. Sie sind ohne unsere vorherige schriftliche Zustimmung nicht berechtigt, Zusicherungen oder Gewährleistungen in Bezug auf unsere Produkte oder Dienstleistungen, Reverse Engineering oder andere Modifizierung unserer Produkte zu machen, oder die Übertragung von Daten an oder von Geotab-Benutzer(n) im Rahmen ihrer Nutzung unserer Produkte oder Dienstleistungen zu überwachen, abzufangen oder zu beeinflussen. Sie müssen immer mindestens eine zertifizierte Person im Personal haben, um Ihren Status als zertifizierter Geotab-Installationsbetrieb beizubehalten. Wenn Sie zu irgendeinem Zeitpunkt keine zertifizierten Personen im Personal haben, müssen Sie uns benachrichtigen, und wir behalten uns das Recht vor, Ihre Ernennung zum zertifizierten Geotab-Installationsbetrieb auszusetzen, bis Sie wieder mindestens eine zertifizierte Person im Personal haben. Sie dürfen nur einen von Geotab genehmigten Kabelbaum verwenden, der von einem autorisierten Geotab-Kanal mit Geotab-Telematikgeräten erfasst wurde. Durch die Nutzung nicht autorisierter Kabelbäume können schwerwiegende Sicherheitsrisiken entstehen, einschließlich Bränden, die zu schweren Körperverletzungen und/oder Schäden am Fahrzeug führen können.
                    2. Laufzeit und Kündigung: Die Erstlaufzeit („Erstlaufzeit“) dieser Vereinbarung beginnt mit dem Datum, an dem wir Ihnen schriftlich bestätigen, dass Ihre Bewerbung akzeptiert wurde, und endet an dem Tag unmittelbar vor dessen dritten Jahrestag, sofern die Vereinbarung nicht anderweitig gekündigt wird. Nach Ablauf der Erstlaufzeit oder einer Laufzeitverlängerung verlängert sich die Vereinbarung automatisch für Folgelaufzeiten von jeweils einem Jahr (jeweils „Laufzeitverlängerung“ und zusammen mit der Erstlaufzeit die „Laufzeit“), es sei denn, eine der Parteien teilt die Nichtverlängerung nach dem Ende der aktuellen Laufzeit oder Laufzeitverlängerung spätestens 120 Tage vor Ablauf dieser Zeit schriftlich mit, oder diese Vereinbarung wird anderweitig gemäß dieser Vereinbarung beendet. Jede Partei kann diese Vereinbarung jederzeit aus beliebigem Grund oder ohne Grund kündigen, indem sie der anderen Partei 30 Tage im Voraus eine schriftliche Mitteilung erteilt. Wenn Sie die geltenden Zertifizierungsanforderungen nicht erfüllen, gilt dies als wesentlicher Verstoß gegen diese Vereinbarung. Sie müssen alle unsere Informationen und Materialien bei Ablauf oder Beendigung der Vereinbarung zurückgeben.
                    3. Versicherung: Während der Laufzeit und für einen Zeitraum von mindestens zwei Jahren danach müssen Sie eine umfassende allgemeine Haftpflichtversicherung mit einer Deckung von mindestens 2 Millionen US-Dollar über Tod, Körperverletzung, Sachschäden, vertragliche Haftung, Betriebshaftpflicht, Werbeverletzung und Produkthaftung sowie jegliche andere Haftung abschließen, die sich aus oder im Zusammenhang mit Ihrem Unternehmen im Rahmen einer Vereinbarung zwischen Ihnen und einem beliebigen Geotab-Benutzer ergeben. Diese Versicherung muss vorsehen, dass Geotab ein zusätzlich benannter Versicherter ist, und dass sie nicht ohne vorherige schriftliche Mitteilung an uns storniert oder geändert wird. Sie müssen uns auf Anfrage eine Bescheinigung über diese Versicherung vorlegen. Der Erwerb einer solchen Versicherungsdeckung entbindet Sie nicht von Ihren Verpflichtungen oder Verbindlichkeiten im Rahmen dieser Vereinbarung.
                    4. Haftungsausschlüsse und Einschränkungen: WIR LEHNEN AUSDRÜCKLICH ALLE AUSDRÜCKLICHEN ODER STILLSCHWEIGENDEN ZUSICHERUNGEN, GARANTIEN UND BEDINGUNGEN AB, EINSCHLIESSLICH ALLER ZUSICHERUNGEN, GARANTIEN UND BEDINGUNGEN FÜR QUALITÄT, LEISTUNG, MARKTGÄNGIGKEIT, MARKTÜBLICHE QUALITÄT, HALTBARKEIT, EIGNUNG FÜR EINEN BESTIMMTEN ZWECK, NICHTVERLETZUNG VON RECHTEN DRITTER, DIE SICH AUS GESETZEN ODER ANDEREN RECHTSLAGEN ODER AUS DER REGELMÄSSIGEN HANDLUNGSWEISE ODER AUS DEM HANDELSVERKEHR ERGEBEN. SIE HALTEN UNSER UNTERNEHMEN, UNSERE LIEFERANTEN, VERTRIEBE, UNTERVERTRIEBE, NACHFOLGER ODER ZESSIONÄRE SOWIE DEREN JEWEILIGE DIREKTOREN, AMTSTRÄGER, ANTEILSEIGNER UND MITARBEITER (JEWEILS „FREIGESTELLTE PARTEI“) SCHADLOS GEGEN JEGLICHE SCHÄDEN, HAFTUNGEN, KOSTEN, VERLUSTE UND AUFWENDUNGEN (EINSCHLIESSLICH ANGEMESSENER RECHTLICHER KOSTEN UND GEBÜHREN), DIE EINER FREIGESTELLTEN PARTEI AUS ODER IM ZUSAMMENHANG MIT EINEM ANSPRUCH, EINER FORDERUNG, EINER BESCHWERDE ODER EINER MASSNAHME DURCH DRITTE IN VERBINDUNG MIT IHREN GESCHÄFTSAKTIVITÄTEN, IHRER FAHRLÄSSIGKEIT ODER IHREM VORSÄTZLICHEN FEHLVERHALTEN ENTSTEHEN KÖNNEN. SIE ERKLÄREN SICH DAMIT EINVERSTANDEN, DASS UNSERE HAFTUNG IHNEN GEGENÜBER, SOWEIT DIES NACH GELTENDEM RECHT ZULÄSSIG IST, IN KEINEM FALL DEN BETRAG ÜBERSTEIGT, DEN SIE UNS IM RAHMEN DIESES VERTRAGS IN DEM ZEITRAUM VON EINEM MONAT UNMITTELBAR VOR DEM AUFTRETEN DES KLAGEGRUNDES GEZAHLT HABEN, UND DASS IN KEINEM FALL EINE FREIGESTELLTE PARTEI FÜR BESONDERE, ZUFÄLLIGE, INDIREKTE ODER FOLGEVERLUSTE ODER -SCHÄDEN, EINSCHLIESSLICH EINNAHME- ODER GEWINNVERLUSTE, HAFTBAR ODER ANDERWEITIG VERANTWORTLICH IST FÜR DEN VERLUST VON DATEN, GESCHÄFTSINFORMATIONEN ODER DEREN NUTZUNGSAUSFALL, DEN VERLUST ERWARTETER GEWINNE ODER EINSPARUNGEN, KAPITALKOSTEN, DEN VERLUST VON GESCHÄFTSCHANCEN, DEN VERLUST VON KULANZEN ODER ANDEREN INDIREKTEN, FINANZIELLEN, KOMMERZIELLEN ODER WIRTSCHAFTLICHEN VERLUSTEN ODER SCHÄDEN JEGLICHER ART ODER ANSPRÜCHEN DRITTER, SELBST WENN DIE FREIGESTELLTE PARTEI DIE MÖGLICHKEIT EINES SOLCHEN VERLUSTES ODER SCHADENS VORHERSEHEN KONNTE ODER VON DER MÖGLICHKEIT EINES SOLCHEN VERLUSTES ODER SCHADENS UNTERRICHTET WURDE.
                    5. Geistiges Eigentum: Alle Handelsnamen, Firmennamen, Handelsmarken, Dienstleistungsmarken, Domainnamen und andere Produkt- und Dienstleistungsnamen und Logos auf unserer Website sind Eigentum von Geotab oder unseren Lizenzgebern und dürfen nur verwendet werden, wenn dies ausdrücklich gestattet wurde. Vorbehaltlich der Bestimmungen dieser Vereinbarung gewähren wir Ihnen ein eingeschränktes, nicht übertragbares, nicht exklusives und gebührenfreies Recht zur Verwendung unserer Handelsmarken, die ausdrücklich von uns als solche identifiziert wurden und von zertifizierten Geotab-Installationsbetrieben verwendet werden können, um Installationsdienste zu vermarkten, zu bewerben, und zu verkaufen. Sie müssen alle Richtlinien einhalten, die wir Ihnen in Bezug auf Ihre Nutzung dieser Richtlinien auferlegen. Wir können Ihre Einhaltung der Vorgaben zu dieser Nutzung von Zeit zu Zeit überprüfen. Sie verstehen und erklären sich damit einverstanden, dass jegliches Feedback, das Sie uns geben, zu unserem exklusiven Eigentum wird. Sie gewähren uns ein eingeschränktes, nicht exklusives und gebührenfreies Recht, Ihren Firmennamen und Ihr Logo zu verwenden, um Sie als zertifizierten Geotab-Installationsbetrieb zu identifizieren und zu fördern, und Sie stimmen zu, dass wir Ihren Namen und Ihre Kontaktinformationen an Geotab-Benutzer oder potenzielle Geotab-Benutzer weitergeben dürfen, die nach Installationsdiensten suchen.
                    6. Vertraulichkeit: Sie erklären sich damit einverstanden, dass alle Ihnen verfügbar gemachten schriftlichen und mündlichen Informationen, die urheberrechtlich geschützt oder vertraulich sind, von Ihnen als vertraulich behandelt werden. Sie dürfen diese Informationen nicht an Dritte weitergeben und dürfen sie ausschließlich für die Zwecke der Erfüllung Ihrer Pflichten im Rahmen dieser Vereinbarung verwenden. Sie müssen uns unverzüglich über jeglichen Missbrauch, jegliche Veruntreuung oder Offenlegung vertraulicher Informationen im Widerspruch zu dieser Vereinbarung informieren.
                    7. Allgemeines: (a) Kommunikation. Sie erklären sich damit einverstanden, Mitteilungen von uns zu erhalten, einschließlich Servicemitteilungen per E-Mail und Postings auf unserer Website. Wir senden Ihnen möglicherweise auch Mitteilungen per Fax, Post, persönlicher Lieferung oder per Kurier, die an die letzte von Ihnen an uns über unsere Website mitgeteilte Adresse oder Nummer gesendet werden. Vorbehaltlich dieser Bestimmung können Sie uns Mitteilungen über unsere Website senden. Sie stimmen zu, dass rechtliche Ansprüche und Forderungen gegen uns als persönliche Zustellung, Einschreiben oder per Kurier gesendet werden müssen an Geotab Inc., 21-1075 North Service Road West Oakville, ON, Canada L6M 2G2, ATTN: General Counsel oder an eine andere Adresse, die wir Ihnen von Zeit zu Zeit gemäß dieser Bestimmung mitteilen. Jede Mitteilung gilt als eingegangen: (i) bei Postversand zehn Werktage nach dem Versand; (ii) bei Kurierzustellung drei Werktage nach Lieferannahme durch den Kurierdienst; (iii) bei persönlicher Zustellung am tatsächlichen Tag der Lieferung, sofern nicht außerhalb der Geschäftszeiten, in diesem Fall gilt dies als Eingang am folgenden Werktag; (iv) bei Zustellung per E-Mail am nächsten Werktag nach dem Absenden; und (v) bei Mitteilung über unsere Website am tatsächlichen Tag, an dem unsere Website bestätigt, dass die Benachrichtigung zugestellt wurde, es sei denn, die Website befindet sich außerhalb der Geschäftszeiten; in diesem Fall gilt der folgende Werktag. (b) Salvatorische Klausel. Soweit ein Teil dieser Vereinbarung als ungültig, rechtswidrig oder nicht durchsetzbar erachtet wird, wird dieser Teil abgesondert und entfernt oder eingeschränkt, sodass die Absichten der Parteien soweit wie möglich umgesetzt werden. (c) Höhere Gewalt. Wir werden von unseren Verpflichtungen im Rahmen dieser Vereinbarung befreit und haften Ihnen oder Dritten gegenüber nicht, wenn wir unsere Verpflichtungen im Rahmen dieser Vereinbarung aufgrund eines Umstands außerhalb unseres zumutbaren Einflussbereichs nicht erfüllen können, so lange wie dieser Umstand uns daran hindert, unseren Verpflichtungen nachzukommen. (d) Geltendes Recht. Diese Vereinbarung unterliegt den Gesetzen der Provinz Ontario und wird entsprechend ausgelegt. Diese Vereinbarung gilt als in der Provinz Ontario geschlossen, und Sie anerkennen hiermit die nicht exklusive Zuständigkeit der Gerichte der Provinz Ontario. (e) Verzichtserklärungen. Kein Verzicht einer der Parteien auf die Verletzung ihrer Abkommen, Verpflichtungen und Vereinbarungen durch die andere Partei stellt einen Verzicht auf eine spätere Verletzung eines anderen Abkommens, einer anderen Verpflichtung oder einer anderen Vereinbarung dar, und ein Verzicht auf Rechtsmittel gegen eine Verletzung stellt keinen Verzicht auf Rechte und Rechtsmittel in Bezug auf diese oder eine spätere Verletzung dar. (f) Unabhängige Vertragspartner. Nichts, was hierin enthalten ist, wird von Ihnen oder uns oder von Dritten als eine Partnerschaft oder ein Joint Venture oder als eine Beziehung zwischen Auftraggeber und Vertreter, Arbeitgeber/Arbeitnehmer, Diener/Bedienter oder Franchisegeber/Franchisenehmer zwischen Ihnen und uns angesehen oder ausgelegt. Sofern nicht ausdrücklich in dieser Vereinbarung festgelegt, gibt nichts in dieser Vereinbarung einer der Parteien die Berechtigung, die andere Partei in irgendeiner Weise zu binden. (g) Abtretung und Vergabe von Unteraufträgen. Sie können Ihre Verpflichtungen aus diesem Vertrag unterbeschäftigen oder delegieren, sofern Sie in diesem Fall nur einen anderen zertifizierten Geotab-Installationsbetrieb beschäftigen oder delegieren sowie für alle Handlungen oder Unterlassungen derer, die Sie unterbeschäftigen und delegieren, verantwortlich und haftbar sind, als ob es sich um Ihre eigenen Handlungen oder Unterlassungen handele, einschließlich aller Verletzungen dieses Vertrags. Sie müssen sicherstellen, dass solche Unterauftragnehmer oder Delegierten die anwendbaren Bestimmungen dieser Vereinbarung einhalten, einschließlich, aber nicht beschränkt auf, die Beschaffung eines Versicherungsschutzes. Wir können diese Vereinbarung oder alle Rechte oder Pflichten aus dieser Vereinbarung ganz oder teilweise abtreten. Sie sind nicht berechtigt, diese Vereinbarung oder Ihre Rechte oder Pflichten aus dieser Vereinbarung abzutreten oder zu übertragen, auch nicht kraft Gesetzes. (h) Gesamte Vereinbarung. Diese Vereinbarung enthält die gesamte Vereinbarung zwischen Ihnen und uns in Bezug auf Ihre Ernennung zum zertifizierten Geotab-Installationsbetrieb und ersetzt alle vorherigen Vereinbarungen zwischen Ihnen und uns in Bezug auf diese Vereinbarung. Es gibt keine Zusicherungen, Gewährleistungen, Bedingungen, Vereinbarungen oder Zusicherungen, weder ausdrücklich noch stillschweigend oder gesetzlich, zwischen Ihnen und uns, außer jene, die ausdrücklich in dieser Vereinbarung festgelegt sind.`,
        },
        stepThree: {
            review: 'Bestätigung',
            companyDetails: 'Unternehmensdaten',
            confirm: 'Bestätigen',
            cancel: 'Abbrechen',
            editDetails: 'Ändern',
            takeTest: 'Test starten',
            thankYou: 'Vielen Dank. Ihr Antrag wurde eingereicht.',
            uniqueKey: 'Ihrem Unternehmen wurde folgende Nutzer-ID zugewiesen:',
            reviewText:
                'Sie müssen die oben genannten Informationen überprüfen und sicherstellen, dass sie wahrheitsgemäß, genau, vollständig und aktuell sind. Falls Änderungen erforderlich sind, nehmen Sie diese vor, bevor Sie fortfahren. Sie erkennen an und verstehen, dass wir uns das Recht vorbehalten, Ihre Bewerbung abzulehnen oder nach Annahme der Bewerbung die Vereinbarung zu beenden und/oder Ihren Status als zertifizierter Geotab-Installationsbetrieb auszusetzen, falls wir feststellen, dass Informationen oder Unterlagen, die Sie im Zusammenhang mit Ihrer Bewerbung bereitgestellt haben, nicht wahrheitsgemäß, genau, vollständig oder aktuell sind. Indem Sie unten auf „Bestätigen“ klicken: (a) reichen Sie Ihre Bewerbung und die oben genannten Informationen bei Geotab ein; (b) sichern Sie zu, garantieren und verpflichten sich, dass Sie die oben genannte juristische Person binden können, dass die von Ihnen oben angegebenen Informationen wahrheitsgemäß, genau, aktuell und vollständig sind, und dass Sie als Vertreter der oben genannten juristischen Person zustimmen, an die oben genannten Bedingungen gebunden zu sein. Wenn Sie mit den Geschäftsbedingungen nicht einverstanden sind oder aus irgendeinem Grund nicht mit der Bewerbung fortfahren möchten, klicken Sie unten nicht auf „Bestätigen“. Klicken Sie unten stattdessen auf „Abbrechen“, um den Vorgang abzubrechen.',
            note: 'Hinweis: Um das Anmeldeverfahren abzuschließen, senden Sie bitte Ihren Versicherungsnachweis und Unternehmenslogo an installercert@geotab.com. Mindestens eine Person aus Ihrem Unternehmen muss die Zertifizierungsprüfung für Installationsbetriebe absolvieren und bestehen.',
        },
        stepLabels: {
            'Company details': 'Unternehmensdaten',
            'Terms and agreement': 'Bedingungen und Vereinbarungen',
            Confirmation: 'Bestätigung',
        },
    },
    successStoriesHome: {
        seo: {
            title: 'Fallstudien und Erfolgsgeschichten | Geotab',
            description:
                'Erfahren Sie, wie Unternehmen die Flottenmanagement-Software von Geotab erfolgreich einsetzen. Sehen Sie sich unsere Fallstudien zum Fuhrparkmanagement und Erfolgsgeschichten zum GPS-Fuhrparkmanagement an.',
        },
        header: 'Success Stories',
        subHeader: 'Filtern nach',
        sortBy: 'Sortieren nach',
        clearFilter: 'Filter entfernen',
        results: 'Ergebnisse',
        notResult:
            'Wir können keine Artikel finden, die diesen Kriterien entsprechen. Passen Sie die Filter an, um mehr Ergebnisse zu erhalten.',
        industry: 'Branche',
        region: 'Region',
        fleetSize: 'Flottengröße',
        fleetFocus: 'Fuhrparkschwerpunkt',
        fleets: 'Flotte',
        fleetSizeFilterList: [
            { content: 'Alle', value: -1 },
            { content: 'kleine', value: 0 },
            { content: 'mittelgroße', value: 1 },
            { content: 'große', value: 2 },
        ],
        fleetRegionFilterList: [
            { content: 'Alle', value: -1 },
            { content: 'Nordamerika', value: 0 },
            { content: 'Lateinamerika', value: 1 },
            { content: 'Europa', value: 2 },
        ],
        fleetIndustryFilterList: [
            { content: 'Alle', value: -1 },
            { content: 'Bus und Personenverkehr', value: 0 },
            { content: 'Baugewerbe', value: 1 },
            { content: 'Kurier- und Lieferdienste', value: 2 },
            { content: 'Außen- und Kundendienst', value: 3 },
            { content: 'Lebensmittel', value: 4 },
            { content: 'Behörden', value: 5 },
            { content: 'Öl, Gas und Bergbau', value: 6 },
            { content: 'Pharmaindustrie', value: 7 },
            { content: 'Polizei & Notdienste', value: 8 },
            { content: 'Shared Mobility', value: 9 },
            { content: 'Abschleppdienste', value: 10 },
            { content: 'Versorgungsunternehmen', value: 11 },
            { content: 'Entsorgung und Recycling', value: 12 },
            { content: 'Winterdienste', value: 13 },
            { content: 'Telekommunikation', value: 14 },
            { content: 'Transport und Logistik', value: 15 },
        ],
        sortByFilterList: [
            { content: 'Neueste', value: 0 },
            { content: 'Älteste', value: 1 },
            { content: 'Titel', value: 2 },
        ],
    },
    authorBiography: {
        authorOverview: {
            leanMoreAbout: 'Mehr über {authorName} erfahren',
        },
        authorPosts: {
            postsBy: 'Beiträge von',
            postBy: 'Beitrag von',
            noPostAvailable: 'Keine Beiträge verfügbar',
        },
        geotabSubscribe: {
            subscribeTo: 'Abonnieren Sie den Geotab Blog',
            description:
                'Erhalten Sie aktuelle Informationen und Tipps zum Thema Fuhrparkmanagement. Sie können sich jederzeit wieder abmelden.',
        },
        subscribeFormMC: {
            subscribe: 'Anmelden',
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            formId: 'eu-blog-global',
            consentTextSentences:
                'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen zu Geotab.com erhalten. Ihre Daten werden gemäß der ',
            consentLinkText: 'Datenschutzrichtlinie von Geotab verwendet.',
            consentLink: 'https://docs.google.com/document/d/1YGouMy1BZtcyF3wGxyKZ0OVYurqh0k7eBL6dNjjWSrk/pub',
        },
        errors: {
            emailOnList: 'Die E-Mail war bereits in unserer Liste, bitte überprüfen Sie hier Ihren Abonnementstatus:',
            unsubscribed:
                'Die E-Mail wurde zuvor abgemeldet. Bitte wenden Sie sich an unseren Administrator, um sie erneut hinzuzufügen.',
            error: 'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut oder wenden Sie sich an Ihren Administrator.',
        },
        readPublications: 'Liste der Veröffentlichungen',
    },
    successStoriesTemplate: {
        publishedOn: 'Veröffentlichungsdatum',
        clientProfile: 'Kundenprofil',
        name: 'Name des Kunden',
        industry: 'Branche',
        typesOfVehicles: 'Fahrzeugarten',
        fleetSize: 'Größe des Fuhrparks',
        fleetFocus: 'Fuhrparkschwerpunkt',
        otherStories: 'Andere Geschichten',
        optimizeYourFleet: 'Wie wäre es mit einer Fuhrparkoptimierung?',
        letUsShowYou:
            'Sehen Sie selbst, wie Sie Ihren Fuhrpark mühelos mit unserer webgestützten Software und den Fuhrparkortungsgeräten verwalten können.',
        requestDemo: 'Demo anfordern',
        requestDemoPath: '/de/demo-anfordern/',
        visitBlog: 'Blog besuchen',
        downloadSuccessStory: 'PDF herunterladen',
    },
    pressRelease: {
        publishedOn: 'Veröffentlichungsdatum',
        mediaContact: {
            title: 'Medienkontakt',
            email: 'pr@geotab.com',
        },
        relatedNews: 'Verwandte Neuigkeiten',
        inTheNews: 'Geotab in den Medien',
    },
    aboutGeotab: {
        main: 'Über Geotab',
        content:
            'Geotab ist ein weltweit führender Anbieter von Lösungen für vernetzte Fahrzeuge, die die Effizienz und das Management von Flotten verbessern. Das Unternehmen nutzt fortschrittliche Datenanalyse und KI, um die Leistung, Sicherheit und Nachhaltigkeit von Flotten zu verbessern, Kosten zu senken und die Effizienz zu steigern. Unterstützt von führenden Fachkräften aus den Bereichen Datenwissenschaft und Ingenieurwesen betreut Geotab über 55.000 Kunden und Kundinnen weltweit und verarbeitet täglich 80 Milliarden Datenpunkte von mehr als 4,7 Millionen Fahrzeugabonnements. Geotab genießt das Vertrauen von Fortune-500-Unternehmen, mittelständischen Flotten und den größten Fuhrparks des öffentlichen Sektors weltweit, einschließlich der US-Bundesregierung. Das Unternehmen engagiert sich für Datensicherheit und Datenschutz und verfügt über die Zertifizierungen FIPS 140-3 und FedRAMP. Geotabs offene Plattform, ein Ökosystem von herausragenden Partnern und der Marketplace bieten Hunderte von flottenfähigen Drittanbieterlösungen. Dieses Jahr feiert Geotab 25 Jahre Innovation. Erfahren Sie mehr unter <a href="https://www.geotab.com/de/" target="_blank">www.geotab.com/de</a>, und folgen Sie uns auf <a href="https://www.linkedin.com/company/geotab/" target="_blank" rel="noopener noreferrer">LinkedIn</a> oder besuchen Sie unseren <a href="https://www.geotab.com/de/blog/" target="_blank">Blog</a>.',
        rights: 'Alle Rechte vorbehalten.',
        disclaimer:
            'Mit diesem Whitepaper sollen Informationen bereitgestellt und Diskussionen über für die Telematik-Community interessante Themen angeregt werden. Geotab bietet über dieses Whitepaper keine technische, fachliche oder rechtliche Beratung an. Trotz aller Bemühungen, um sicherzustellen, dass die Informationen in diesem Whitepaper zeitnah und präzise sind, können Fehler und Unterlassungen auftreten, und die hier dargelegten Informationen können im Laufe der Zeit nicht mehr aktuell sein.',
    },
    recentNews: 'Neuigkeiten',
    relatedPosts: 'Verwandte Beiträge',
    generalInquiries: {
        seo: {
            title: 'Allgemeine Anfragen | Geotab',
            description:
                'Haben Sie eine Frage zu Geotab und unseren Produkten? Bitte füllen Sie unten das Formular aus, damit wir Sie so bald wie möglich kontaktieren können.',
        },
        heroImagePath: contactUs.generalInquiriesHeroImage,
        title: 'Allgemeine Anfragen',
        header: 'Kontaktieren Sie uns',
        subtext:
            'Haben Sie eine Frage? Bitte füllen Sie das untenstehende Formular aus, damit wir Sie so bald wie möglich kontaktieren können.',
        inquiryType: 'Other',
    },
    salesInquiries: {
        seo: {
            title: 'Vertriebsanfrage | Geotab',
            description:
                'Wenn Sie Fragen oder Kommentare zum Kauf unserer Produkte oder Lösungen haben, füllen Sie bitte das folgende Formular aus. Wir werden Sie so bald wie möglich kontaktieren.',
        },
        heroImagePath: contactUs.salesInquiryHeroImage,
        title: 'Vertriebsanfrage',
        header: 'Vertrieb kontaktieren',
        subtext:
            'Wenn Sie Fragen oder Kommentare zum Kauf unserer Produkte oder Lösungen haben, füllen Sie bitte das folgende Formular aus. Wir werden Sie so bald wie möglich kontaktieren.',
        inquiryType: 'Sales',
    },
    contactGeneralInquiry: {
        formField: {
            fullName: 'Vollständiger Name',
            company: 'Firma',
            email: 'E-Mail-Adresse',
            selectFleetSize: 'Größe des Fuhrparks',
            phone: 'Telefon',
            selectCountry: 'Land',
            city: 'Ort',
            comments: 'Fragen/Kommentare:',
            checkboxText:
                'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen von Geotab.com erhalten. Ihre Daten werden gemäß der Datenschutzrichtlinie von Geotab verwendet.',
            submit: 'Senden',
        },
    },
    blogPost: {
        publishedOn: 'Veröffentlicht am',
        updatedOn: 'Zuletzt geupdated am',
        categoryIn: 'in',
        publishedBy: 'von',
        relatedPosts: 'Verwandte Beiträge',
        likeButtonText: 'Wenn Ihnen dieser Beitrag gefallen hat, lassen Sie es uns wissen!',
        likeButtonAriaText: 'Gefällt mir',
        category: 'Kategorie',
        disclaimerTitle: 'Haftungsausschluss',
        disclaimerSummary:
            'Geotabs Blogbeiträge sollen Informationen bereitstellen und Diskussionen über Themen anregen, die für die gesamte Telematik-Gemeinschaft von Interesse sind. Geotab bietet durch diese Blogbeiträge keine technische, professionelle oder rechtliche Beratung an. Obwohl alle Bemühungen unternommen wurden, um sicherzustellen, dass die Informationen in diesem Blogbeitrag zeitnah und genau sind, können Fehler und Auslassungen auftreten, und die hier präsentierten Informationen können Laufe der Zeit veraltet sein.',
        share: 'Teilen',
        shareArticle: 'Artikel teilen',
        copyUrl: 'URL Kopieren',
        copiedUrlMessage: 'Kopiert',
        shareWith: 'Teilen mit',
        keyInsights: 'Wichtige Einlicke',
        keyTakeaways: 'Wichtigste Einblicke',
    },
    renderChips: {
        postTags: 'Post-Tags',
        tag: 'tag',
    },
    articleCard: {
        viewLink: 'Ansehen',
    },
    platformPartnersForm: {
        howToGetStarted: 'Nächste Schritte',
        formField: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            company: 'Firma',
            email: 'E-Mail-Adresse',
            phone: 'Telefon',
            areaOfInterest: {
                label: 'Interessengebiet',
                options: ['Bring Your Own UI', 'Bring Your Own Device', 'IoT-Konnektivität'],
            },
            comments: 'Fragen/Kommentare:',
            submitButton: 'Senden',
        },
    },
    securityForm: {
        formField: {
            fullName: 'Vollständiger Name',
            email: 'E-Mail-Adresse',
            message: 'Nachricht',
        },
        submit: 'Senden',
        thankYou:
            'Vielen Dank, unser Sicherheitsteam wird sich so bald wie möglich mit Ihnen in Verbindung setzen.\u00A0',
    },
    imagePopout: {
        readPrevious: 'Zurück',
        readNext: 'Weiter',
    },
    softwarePackages: deSoftwarePackages,
    requestDemo: {
        optimizeYourFleetToday: 'Optimieren Sie Ihren Fuhrpark noch heute!',
        formField: {
            leadSource: 'Geotab Demo Form',
            firstName: 'Vorname',
            lastName: 'Nachname',
            company: 'Unternehmen',
            email: 'E-Mail',
            selectFleetSize: 'Größe des Fuhrparks wählen',
            phone: 'Rufnummer',
            selectCountry: 'Land wählen',
            city: 'Ort',
            selfAttribution: 'Wie haben Sie von uns erfahren?',
            consentText:
                'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen zu Geotab.com erhalten. Ihre Daten werden gemäß der <a href="https://docs.google.com/document/d/1YGouMy1BZtcyF3wGxyKZ0OVYurqh0k7eBL6dNjjWSrk/pub" rel="noopener" target="_blank">Datenschutzrichtlinie</a> von Geotab verwendet.',
            requestAFreeDemo: 'Kostenlose Demo anfordern',
        },
    },
    evLeadForm: {
        title: 'Optimieren Sie Ihre Elektroflotte',
        subTitle:
            'Um eine Demo zum E-Fahrzeug-Reporting oder um weitere Informationen über E-Fahrzeug-Leistung zu erhalten, füllen Sie bitte das unten stehende Formular aus. Wir werden Sie so schnell wie möglich kontaktieren.',
        formField: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            phone: 'Telefon',
            email: 'E-Mail-Adresse',
            company: 'Firma',
            fleetSize: 'Größe des Fuhrparks',
            selectCountry: 'Land',
            city: 'Ort',
            identify: 'Bitte helfen Sie uns zu ermitteln, wer Sie sind:',
            userType: {
                resellerType: 'Geotab-Vertriebspartner',
                newCustomerType: 'Neuer Geotab-Kunde',
                existCustomerType: 'Bestehender Geotab-Kunde',
            },
            consentTextSentences: [
                'Ja, ich möchte Marketingmitteilungen zu Produkten, Dienstleistungen und Veranstaltungen von Geotab erhalten. Die Daten werden in Übereinstimmung von ',
            ],
            consentLinkText: 'Datenschutzrichtlinien von Geotab verwendet',
            consentLink: 'https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub',
            submit: 'Senden',
        },
    },

    readMore: 'Mehr erfahren',
    findInstaller: {
        title: 'Autorisierten Geotab-Montagebetrieb in der Nähe finden',
        searchPlaceholder: 'Suchen Sie nach Name, Stadt, Bundesland oder Region, Land',
    },
    formPlaceholders: {
        firstNamePlaceholder: 'Vorname angeben\u2026',
        lastNamePlaceholder: 'Nachname angeben\u2026',
        phonePlaceholder: 'Rufnummer angeben\u2026',
        emailPlaceholder: 'E-Mail angeben\u2026',
        companyPlaceholder: 'Unternehmen angeben\u2026',
        cityPlaceholder: 'Ort angeben\u2026',
        commentsPlaceholder: 'Geben Sie Fragen / Kommentare ein\u2026',
        fleetPlaceholder: 'Größe des Fuhrparks wählen\u2026',
        countryPlaceholder: 'Land wählen\u2026',
        fullNamePlaceholder: 'Vollständiger Name angeben\u2026',
        messagePlaceholder: 'Verfassen Sie eine Nachricht\u2026',
        surnamePlaceholder: 'Nachname angeben\u2026',
        identityPlaceholder: 'Kategorie auswählen\u2026',
        statePlaceholder: '',
        provincePlaceholder: '',
        titlePlaceholder: 'Wählen Sie eine Berufsbezeichnung\u2026',
        userTitlePlaceholder: 'Geben Sie Ihre Berufsbezeichnung ein\u2026',
        clientPlaceholder: 'Bitte helfen Sie uns, Sie zu identifizieren\u2026',
        industryPlaceholder: 'Wählen Sie eine Branchenkategorie aus\u2026',
        subIndustryPlaceholder: 'Wählen Sie eine Subbranche aus\u2026',
        selfAttributionPlaceholder: 'Geben Sie an, wie Sie von Geotab erfahren haben\u2026',
    },
    formTranslations: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        company: 'Firma',
        email: 'E-Mail-Adresse',
        phone: 'Telefon',
        city: 'Ort',
        country: 'Land',
        interest: 'Interessenbereich',
        industry: 'Branche',
        subIndustry: 'Subbranche',
        client: 'Client-Typ',
        fleetSize: 'Flottengröße',
        submit: 'Senden',
        yes: 'Ja',
        no: 'Nein',
        yesToProceed: 'Bitte wählen Sie oben Ja, um fortzufahren',
        checkedToProceed: 'Bitte aktivieren Sie das Kontrollkästchen oben, um fortzufahren',
        state: 'Bundesland',
        province: 'Region',
        title: 'Berufsbezeichnung',
        userTitle: 'Ihre Berufsbezeichnung',
        forceMultiPick: 'Wählen Sie mindestens zwei Optionen',
    },
    regionSelection: {
        seo: {
            title: 'Auswahl der Region',
            description:
                'Wählen Sie Ihr Land oder Ihre Region aus, um mehr über die Fuhrparkmanagement-Software und Fahrzeugortungsgeräte von Geotab zu erfahren.',
        },
        title: 'Wählen Sie Ihre Region',
        regions: {
            northSouthAmerica: 'Nord- und Südamerika',
            europe: 'Europa',
            asiaAustraliaMiddleEast: 'Asien, Australien und Mittlerer Osten',
        },
        regionChangeText: 'Standort wechseln',
    },
    search: {
        seo: {
            title: 'Suchergebnisse für',
        },
        search: 'Suche',
        searchBarPlaceholder: 'Suchen Sie nach Themen, Artikeln, Dokumenten und mehr.',
        searchResults: 'Suchergebnisse',
        showing: '',
        of: 'von',
        results: 'Sucherebnissen',
        noResults: {
            sorryMessage: 'Es wurden leider keine Ergebnisse für',
            invalidSearch: 'Ihre Sucheingabe ist leider ungültig.',
            searchTips: 'Hinweise zur Suche',
            spellingCheck: 'Prüfen Sie die Schreibweise und versuchen Sie es erneut.',
            simplerTerms: 'Suchen Sie nach einfacheren, kürzeren Begriffen.',
            lessSpecific: 'Suchen Sie nach etwas Allgemeinerem.',
            differentWords:
                'Versuchen Sie es mit anderen Schlüsselwörtern oder wählen Sie einen anderen Datumsbereich.',
        },
        filter: {
            contentType: 'Art des Inhalts',
            filterButtonText: 'Filter',
            applyFilters: 'Filter anwenden',
            clearFilters: 'Filter löschen',
        },
        dateSelection: {
            dateUpdated: 'Datum der Aktualisierung',
            all: 'Alle',
            30: 'Letzte 30 Tage',
            90: 'Letzte 90 Tage',
            365: 'Letztes Jahr',
        },
    },
    entityHomeNames: {
        blogArticle: 'Blog',
        pressReleaseArticle: 'Pressemeldungen',
        whitePaperArticle: 'White Paper',
        successStoryArticle: 'Success Stories',
        glossaryArticle: 'Glossar',
    },
    entityNames: {
        blogArticle: 'Blogartikel',
        pressReleaseArticle: 'Pressemeldung',
        whitePaperArticle: 'White Paper',
        successStoryArticle: 'Success Story',
        page: 'Webpage',
        author: 'Autor',
        category: 'Kategorie',
        tag: 'Tag',
        video: 'Video',
        document: 'Dokument',
        glossaryArticle: 'Glossar',
    },
    blogTableContent: {
        title: 'Inhaltsübersicht',
    },
    articleFAQ: {
        title: 'Häufig gestellte Fragen',
    },
    blogInfo: {
        readMinutes: 'Lesedauer: 5 Minuten',
        by: 'Von',
    },
    glossary: {
        articleCard: {
            definition: 'Definition',
            publishedOn: 'Veröffentlicht am',
            updatedOn: 'Zuletzt geupdated am',
            readMinutes: 'Lesedauer: 5 Minuten',
            share: 'Teilen',
            otherStories: 'Andere Geschichten',
        },
    },
    noBlogsFound: {
        forAuthor: 'Keine Blog-Beiträge gefunden von',
        forCategory: 'Keine Blog-Beiträge gefunden für',
        forTag: 'Keine Ergebnisse gefunden mit dem Tag',
        noArticlesFound: 'Es konnten keine Ergebnisse gefunden werden. Versuchen Sie, Ihre Filter anzupassen.',
    },
    aboutAuthor: {
        about: 'Über',
        currentRole: 'Derzeitige Position',
        experties: 'Fachwissen',
        accomplishments: 'Erreichte Ziele',
        education: 'Bildung',
        publications: 'Veröffentlichungen',
    },
    mobileStickyBanner: {
        text: 'Demo anfordern',
        link: '/de/demo-anfordern/',
    },
    breadcrumb: {
        home: 'Home',
    },
    contactSection: {
        title: 'KONTAKTIEREN SIE UNS',
        subHeading: 'Wie können wir Ihnen heute behilflich sein?',
        salesInquiryText: 'Vertriebsanfrage',
        salesInquiryImageAlt: 'Price tag icon',
        salesInquiryLink: '/de/kontakt/vertriebsanfrage/',
        customerSupportText: 'Kundensupport',
        customerSupportImageAlt: 'Customer chat icon',
        customerSupportLink: 'https://support.geotab.com/de-DE',
        contactLinks: [
            {
                title: 'Demo anfordern',
                href: 'https://www.geotab.com/de/demo-anfordern/',
            },
            {
                title: 'Werden Sie Fachhändler',
                href: 'https://www.geotab.com/de/kontakt/fachhaendler-werden/',
            },
        ],
    },
};
